const STATIC_MEMRISE_BASE = 'https://static.memrise.com/';

export function resolveLearnableImageUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  if (value.startsWith('uploads/items/')) {
    return `${STATIC_MEMRISE_BASE}${value}`;
  }
  if (value.startsWith(STATIC_MEMRISE_BASE)) {
    return value;
  }
  return null;
}
